import { actionTypesFor, FilterActionResult } from "./filter.actions"

export enum FilterableEntities {
  Users = "USERS",
  Availabilities = "AVAILABILITIES",
  AvailabilitiesWeek = "AVAILABILITIES_WEEK",
  Absences = "ABSENCES",
}

export type FilterState<Filters> = {
  filters: Filters
  filterableFields: { [k: string]: string[] }
}

export const DEFAULT_STATE: FilterState<any> = {
  filters: {},
  filterableFields: {},
}

function createFilterReducer<T>(
  entityName: FilterableEntities,
): (state: FilterState<T>, action: FilterActionResult<T>) => FilterState<T> {
  return (state = DEFAULT_STATE, action: { type: string; payload?: any }) => {
    const { CHANGE_FILTERS, RESET, SET_FILTERABLE_FIELDS } = actionTypesFor(entityName)

    if (!action.type || !action.payload) {
      return state
    }

    switch (action.type) {
      case CHANGE_FILTERS: {
        return { ...state, filters: action.payload.filters }
      }

      case RESET: {
        return { ...state, filters: {} }
      }

      case SET_FILTERABLE_FIELDS: {
        if (!state.filterableFields[action.payload.filterableField]) {
          return state
        }
        return {
          ...state,
          filterableFields: {
            ...state.filterableFields,
            [action.payload.filterableField]: [...action.payload.filterableFieldsValues],
          },
        }
      }

      default:
        return state
    }
  }
}

export default createFilterReducer
